import React from "react";
import AuthRebrandFrame from "./AuthRebrandFrame";

const Verifylayout = ({ children }) => {
  return <AuthRebrandFrame>{children}</AuthRebrandFrame>;
};

export default Verifylayout;
